export const HOME = '/';
export const PACKAGES = '/packages';
export const SESSION = '/session';
export const RESTRICTED = '/restricted';
